<template>
  <div class="label-root">
    <div class="label-wrap">
      <div class="label-header">
        <div
          class="label-carrier-logo"
          :style="{
            backgroundImage: `url(${publicPath}carrier-logos/${carrier.logo})`,
          }"
        ></div>
      </div>
      <div class="label-body">
        <div class="label-text">
          Receiver:
        </div>
        <div class="label-address">
          {{ name }}
        </div>
        <div class="label-address">
          Hill Street 110
        </div>
        <div class="label-address">
          {{ country || "The Netherlands" }}
        </div>
      </div>
      <div class="label-details-wrap">
        <div class="qr-code-wrap">
          <div class="qr-code"></div>
        </div>
      </div>
      <div class="label-no-info">
        <div class="label-no-info-row">
          <div class="label-no-text">
            052 8992
          </div>
          <div class="label-no-text">{{ carrier.text }}-B2B</div>
        </div>
        <div class="large-label-no">
          NL-052
        </div>
      </div>
      <div class="label-barcode"></div>
      <div class="label-no-wrap">
        <div class="label-code">
          0563 5359 3011 5949 112 8356 2789
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShippingLabel",
  props: ["name", "carrier", "country"],
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style scoped>
.label-address {
  width: 143px;
  min-height: null;
  margin: 5px 0px 0px 0px;
  font-weight: 600;
}

.label-barcode {
  display: flex;
  width: 100%;
  min-height: 52px;
  margin: 0px 0px 0px 0px;
  background: url(https://firebasestorage.googleapis.com/v0/b/handoff-59cbc.appspot.com/o/projects%2FcyrvTKKfwKNvMZSTpNyi%2Fimages%2FBarcode.svg?alt=media&token=d6468510-28d3-400c-970c-1bc5ad935e58);
  border: 1px null black;
  border-top: 3px solid black;
}

.label-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 10px 0px 10px 0px;
  border: 1px null black;
  border-bottom: 1px solid black;
  font-size: 14px;
}

.label-carrier-logo {
  display: flex;
  width: 60px;
  height: 25px;
  margin: 0px 0px 0px 0px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 1px null black;
}

.label-code {
  min-height: null;
  font-weight: 600;
  text-align: center;
}

.label-details-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  margin: 0px 0px 10px 0px;
  border: 1px null black;
  border-bottom: 2px solid black;
}

.label-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  min-height: 33px;
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 10px 0px;
  border: 1px null black;
  border-bottom: 2px solid black;
}

.label-no-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 10px 0px;
  border: 1px null black;
  border-bottom: 1px null black;
}

.label-no-info-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  min-height: 23px;
  margin: 0px 0px 0px 0px;
  border: 1px null black;
  font-size: 16px;
}

.label-no-text {
  min-height: null;
  margin: 0px 0px 0px 0px;
  font-weight: 600;
  font-size: 15px;
}

.label-no-wrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 30px;
  border: 1px null black;
  font-size: 10.5px;
}

.label-root {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: sans-serif, Arial;
}

.label-text {
  min-height: null;
  margin: 0px 0px 0px 0px;
  font-size: 14px;
}

.label-wrap {
  position: relative;
  z-index: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 320px;
  padding: 25px 25px 25px 25px;
  background: linear-gradient(to right, RGB(255, 255, 255), RGB(255, 255, 255));
  border: 1px solid rgb(235, 235, 235);
  border-radius: 5px;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.15);
  font-size: 10px;
}

.large-label-no {
  width: 118px;
  min-height: null;
  margin: 5px 0px 0px 0px;
  font-weight: 800;
  font-size: 25px;
  text-align: center;
}

.qr-code {
  display: flex;
  width: 100%;
  min-height: 95px;
  margin: 0px 0px 0px 0px;
  background: url(https://firebasestorage.googleapis.com/v0/b/handoff-59cbc.appspot.com/o/projects%2FcyrvTKKfwKNvMZSTpNyi%2Fimages%2Fqr-%5E_%5E.svg?alt=media&token=d674b6e0-b675-44dc-9392-bb4c312d63bf);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 1px null black;
}

.qr-code-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 121px;
  min-height: 108px;
  padding: 10px 10px 10px 10px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 1px null black;
  border-left: 1px solid black;
}
</style>
